export const DBAS_RESET_STATE = 'DBAS_RESET_STATE';
export const DBAS_CURRENT_ITEM = 'DBAS_CURRENT_ITEM';

export const DBAS_REQUEST_LOADING = 'DBAS_REQUEST_LOADING';
export const DBAS_REQUEST_SUCCESS = 'DBAS_REQUEST_SUCCESS';
export const DBAS_REQUEST_FAILED = 'DBAS_REQUEST_FAILED';

export const DBAS_CURRENT_ACTION = 'DBAS_CURRENT_ACTION';
export const DBAS_RESET_ACTION = 'DBAS_RESET_ACTION';